import { SearchType } from '@aibees/elephant/types';
import { Workspace } from '@aibees/shared/definition';
import {
  recordOwnershipFilterLabelParser,
  recordOwnershipFilterValueFormatter,
} from '../components/filter-tags/utils';
import {
  FilterCategory,
  SearchFilter,
  SearchFilterBase,
  SearchFilterType,
} from '../types';
import { workspaceResponseMapper } from '../utils';

export default function recordsOwnershipFilterConfig(
  searchType: SearchType
): SearchFilterBase {
  const companiesRecordsOwnership: SearchFilter = {
    name: 'Companies',
    type: SearchFilterType.NONE,
    index: 0,
    field: 'record_ownership_contact',
    key: 'record_ownership_contact',
    metadata: {
      tabs: {
        icon: 'business',
        iconColor: 'primary',
      },
    },
    utils: {
      tags: {
        config: {
          showAsCard: true,
          tagsCardTitle: 'Companies Records',
        },
      },
    },
    nested: true,
    open: true,
    items: [
      {
        name: 'Include',
        type: SearchFilterType.CUSTOM_SELECT,
        index: 0,
        field: 'record_ownership_contact_include',
        key: 'record_ownership_contact_include',
        metadata: {
          color: 'primary',
          icon: 'add-circle-outline',
          placeholder: 'Specify Owner',
          delimiter: '::',
          autocomplete: {
            onlySearchInResults: true,
          },
        },
        searchKey: 'name',
        config: { labelKey: 'name', valueKey: 'id' },
        utils: {
          optionsApiFormatter: (data?: Workspace[]) =>
            workspaceResponseMapper(data),
          valueFormatter: recordOwnershipFilterValueFormatter,
          tags: {
            labelFormatter: recordOwnershipFilterLabelParser,
          },
        },
        options: [
          {
            type: 'URL',
            value: '/customer-management/um/workspaces?name&page=0&size=1',
            label: '',
            icon: null,
            index: undefined,
          },
        ],
      },
      {
        name: 'Exclude',
        type: SearchFilterType.CUSTOM_SELECT,
        index: 0,
        field: 'record_ownership_contact_exclude',
        key: 'record_ownership_contact_exclude',
        metadata: {
          color: 'error',
          icon: 'block',
          placeholder: 'Specify Owner',
          delimiter: '::',
          autocomplete: {
            onlySearchInResults: true,
          },
        },
        searchKey: 'name',
        config: { labelKey: 'name', valueKey: 'id' },
        utils: {
          optionsApiFormatter: (data?: Workspace[]) =>
            workspaceResponseMapper(data),
          valueFormatter: recordOwnershipFilterValueFormatter,
          tags: {
            labelFormatter: recordOwnershipFilterLabelParser,
          },
        },
        options: [
          {
            type: 'URL',
            value: '/customer-management/um/workspaces?name&page=0&size=1',
            label: '',
            icon: null,
            index: undefined,
          },
        ],
      },
    ],
  };
  const peopleRecordsOwnership: SearchFilter = {
    name: 'People',
    disabled: true,
    comingSoon: true,
    type: SearchFilterType.NONE,
    index: 0,
    field: 'record_ownership_account',
    key: 'record_ownership_account',
    metadata: {
      tabs: {
        icon: 'people',
        iconColor: 'success',
      },
    },
    utils: {
      tags: {
        config: {
          showAsCard: true,
          tagsCardTitle: 'Contacts Records',
        },
      },
    },
    nested: true,
    items: [
      {
        name: 'Include',
        type: SearchFilterType.CUSTOM_SELECT,
        index: 0,
        field: 'record_ownership_account_include',
        key: 'record_ownership_account_include',
        metadata: {
          color: 'primary',
          icon: 'add-circle-outline',
          placeholder: 'Specify Owner',
          delimiter: '::',
          autocomplete: {
            onlySearchInResults: true,
          },
        },
        searchKey: 'name',
        config: { labelKey: 'name', valueKey: 'id' },
        utils: {
          optionsApiFormatter: (data?: Workspace[]) =>
            workspaceResponseMapper(data),
          valueFormatter: recordOwnershipFilterValueFormatter,
          tags: {
            labelFormatter: recordOwnershipFilterLabelParser,
          },
        },
        options: [
          {
            type: 'URL',
            value: '/customer-management/um/workspaces?name&page=0&size=1',
            label: '',
            icon: null,
            index: undefined,
          },
        ],
      },
      {
        name: 'Exclude',
        type: SearchFilterType.CUSTOM_SELECT,
        index: 0,
        field: 'record_ownership_account_exclude',
        key: 'record_ownership_account_exclude',
        metadata: {
          color: 'error',
          icon: 'block',
          placeholder: 'Specify Owner',
          delimiter: '::',
          autocomplete: {
            onlySearchInResults: true,
          },
        },
        searchKey: 'name',
        config: { labelKey: 'name', valueKey: 'id' },
        utils: {
          optionsApiFormatter: (data?: Workspace[]) =>
            workspaceResponseMapper(data),
          valueFormatter: recordOwnershipFilterValueFormatter,
          tags: {
            labelFormatter: recordOwnershipFilterLabelParser,
          },
        },
        options: [
          {
            type: 'URL',
            value: '/customer-management/um/workspaces?name&page=0&size=1',
            label: '',
            icon: null,
            index: undefined,
          },
        ],
      },
    ],
  };

  return {
    id: 'Record Ownership',
    name: 'Record Ownership',
    icon: 'account-tag',
    comingSoon: true,
    disabled: true, // TODO: after enabling refactor config because the filter type has been changed
    index: 1,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.RECORD_MANAGEMENT],
    items: [
      {
        name: '',
        type: SearchFilterType.BUTTON_GROUP,
        icon: undefined,
        index: 0,
        key: '',
        field: '',
        metadata: {
          allowParallelItems: true,
          tabs: {
            defaultOpenIndex: searchType === SearchType.Company ? 0 : 1,
          },
        },
        config: { labelKey: 'label', valueKey: 'value' },
        items: [
          {
            name: 'Applied Filters',
            type: SearchFilterType.APPLIED_FILTERS,
            index: 2,
            icon: undefined,
            key: 'record_ownership_applied_filters',
            field: 'record_ownership_applied_filters',
            metadata: {},
          },
          companiesRecordsOwnership,
          peopleRecordsOwnership,
        ],
      },
    ],
  };
}
